
























import { defineComponent } from '@nuxtjs/composition-api';
import { focus } from '@shared/ui/utilities/directives';

import BaseLink from '../BaseLink/BaseLink.vue';
export default defineComponent({
  name: 'BaseButton',
  directives: {
    focus,
  },
  inject: {
    components: {
      default: { BaseLink },
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
      // @ts-ignore migrated from ui-library
      validator: (value) => ['button', 'submit', 'reset'].includes(value),
    },
    link: {
      type: [String, Object],
      default: null,
    },
  },
  // @ts-ignore migrated from ui-library
  linkActive(link, disabled) {
    return link && disabled;
  },
  // @ts-ignore migrated from ui-library
  buttonActive(link, disabled) {
    return !link && disabled;
  },
});
